import React from "react";
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { listNftByStatus } from "services/apiService";
import MDAvatar from "components/MDAvatar";
import { useMediaQuery } from "react-responsive";
import InfiniteScroll from "react-infinite-scroll-component";
import singhCoinCurrency from "assets/images/singhCoinCurrency.png";
import MDButton from "components/MDButton";
import SpinLoader from "components/SpinLoader";
import Moment from "react-moment";
import "moment-timezone";
import moment from "moment";
import MDBadge from "components/MDBadge";
import { useDispatch, useSelector } from "react-redux";
import { fetchListNftByStatus } from "Store/slices/nftSlice";
import { nftListByStatusReducerPlus } from "Store/slices/nftSlice";

function SeeAll() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { nftListByStatus } = useSelector((state) => state.nftMarketPlaceData);
  const { listNft, count, pageNumber } = nftListByStatus;

  const {
    isWeb3Enabled,
    address,
    chainId,
    balance,
    reward,
    isWalletLoading,
    isRewardLoading,
  } = useSelector((state) => state.walletData);

  const [searchParams] = useSearchParams();
  // const [listNft, setListNft] = useState([]);
  // const [count, setCount] = useState(0);
  // const [pageNumber, setPageNumber] = useState(0);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  useEffect(() => {
    fetchListNftByStatusData();
  }, []);

  const fetchListNftByStatusData = async () => {
    dispatch(
      fetchListNftByStatus({ number: 0, status: searchParams.get("status") })
    );
    //createAsyncThunk byDefault allows only one parameter so passing 1 object and destructuring
  };

  const fetchMoreData = async (number) => {
    // console.log("pageNumberINSIDE1", pageNumber);
    const listNftByStatusResNew = await listNftByStatus(
      number,
      searchParams.get("status")
    );

    if (listNftByStatusResNew.status === 200) {
      dispatch(nftListByStatusReducerPlus(listNftByStatusResNew.data));
    }
  };

  const handleAuctionDetail = (value) => {
    // navigate(`/auction/auctiondetails/?auctionId=${auctionId}`);
    navigate(`/auction-details/?auctionId=${value}`);
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        sx={{
          // marginRight: isTabletOrMobile ? "5%" : "5%",
          // marginLeft: isTabletOrMobile ? "5%" : "5%",
          marginBottom: "2rem",
          // alignItems: "center",
        }}
      >
        <MDBox>
          <MDAvatar
            sx={{
              color: "#8613A5",
              backgroundColor: "#8613A5",
              position: "absolute",
              zIndex: "-1",
              width: isTabletOrMobile ? "3rem" : "3.5rem",
              height: isTabletOrMobile ? "3rem" : "3.5rem",
              left: isTabletOrMobile ? "7px" : "5px",
              top: isTabletOrMobile ? "72px" : "76px",
            }}
          />
          <MDTypography
            sx={{
              color: "#ffffff",
              fontSize: "22px",
              marginTop: "14px",
              marginLeft: "18px",
            }}
            fontWeight="bold"
          >
            {searchParams.get("status")}
          </MDTypography>
          &nbsp;
        </MDBox>
        <InfiniteScroll
          dataLength={listNft.length}
          next={() => fetchMoreData(pageNumber + 1)}
          hasMore={listNft.length < count}
          loader={
            <MDBox sx={{ textAlign: "center" }}>
              <SpinLoader />
            </MDBox>
          }
        >
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <MDBox
              sx={{
                maxWidth: "860px",
                display: "flex",
                justifyContent: "start",
                flexWrap: "wrap",
                // gap: isDesktopOrLaptop ? "9%" : "1%",
                rowGap: "10px",
              }}
            >
              {listNft.length > 0 &&
                listNft.map((item, idx) => (
                  <Card
                    key={idx}
                    sx={{
                      cursor: "pointer",

                      flexBasis: `calc(100% / ${
                        isTabletOrMobile ? 2 : 3
                      } - 5px)`,

                      // height: isTabletOrMobile ? "365px" : "385px",

                      marginLeft: "5px",
                      backgroundColor: "#052330",
                    }}
                    onClick={() => handleAuctionDetail(item._id)}
                  >
                    <MDBox
                      sx={{
                        //  height: isTabletOrMobile ? "240px" : "260px"
                        height: "320px",
                      }}
                    >
                      <img
                        src={item.postDetails.photo}
                        style={{
                          objectFit: "cover",
                          borderRadius: "10px 10px 0px 0px",
                          height: "100%",
                          width: "100%",
                        }}
                      />
                    </MDBox>

                    {searchParams.get("status") === "Time Auction" && (
                      <MDBadge
                        variant="contained"
                        sx={{
                          position: "absolute",
                          top: 10,
                        }}
                        color="warning"
                        badgeContent={
                          <>
                            <MDBox // box to hide (-)sign before timer
                              sx={{
                                position: "absolute",
                                left: 15,
                                border: "1px solid #F5D243",
                                width: 5,
                              }}
                            ></MDBox>
                            <MDTypography
                              color="black"
                              // fontWeight="bold"
                              fontSize="11px"
                            >
                              <Moment
                                durationFromNow
                                interval={1000}
                                date={moment
                                  .utc(item.endDateTimeAuction)
                                  .local()
                                  .startOf("day")
                                  .format()}
                                // date={item.endDateTimeAuction}
                                format="D[ Days] HH:mm:ss"
                                // subtract={{ hours: 5, minutes: 30 }}
                              ></Moment>
                            </MDTypography>
                          </>
                        }
                      />
                    )}

                    <MDBox sx={{ padding: 1 }}>
                      <MDBox
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <MDBox
                          sx={{
                            display: "flex",
                            gap: "0.5rem",
                            alignItems: "center",
                          }}
                        >
                          <MDBox>
                            <MDAvatar
                              src={item.userDetails.pic}
                              size="xs"
                              sx={{
                                width: isTabletOrMobile ? "30px" : "40px",
                                height: isTabletOrMobile ? "30px" : "40px",
                              }}
                              imgProps={{
                                style: { height: "100%", width: "100%" },
                              }}
                            />
                          </MDBox>
                          <MDBox>
                            <MDTypography
                              fontWeight="bold"
                              sx={{
                                fontSize: isTabletOrMobile ? "10px" : "12px",
                                width: isTabletOrMobile ? "50px" : "80px",
                              }}
                              overflow="hidden"
                              textOverflow="ellipsis"
                              whiteSpace="nowrap"
                              // width="80px"
                            >
                              {item.name}
                            </MDTypography>
                            <MDTypography
                              sx={{
                                fontSize: isTabletOrMobile ? "10px" : "12px",
                                width: isTabletOrMobile ? "50px" : "80px",
                                color: "#BDAAC1",
                              }}
                              overflow="hidden"
                              textOverflow="ellipsis"
                              whiteSpace="nowrap"
                              // width="80px"
                            >
                              by @{item.userDetails.username}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                        {item.price === null ||
                        item.price === undefined ||
                        item.price === 0 ||
                        item.price === "0" ? null : (
                          <MDBox
                            sx={
                              {
                                //  textAlign: "end"
                              }
                            }
                          >
                            <MDBox
                              sx={{
                                display: "flex",
                                // justifyContent: "space-between",
                                // textAlign: "start",
                                // marginRight: "-25px",
                              }}
                            >
                              <MDBox sx={{ height: "30px", width: "30px" }}>
                                <img
                                  src={singhCoinCurrency}
                                  height="100%"
                                  width="100%"
                                  alt="currentSymbol"
                                />
                              </MDBox>
                              <MDBox sx={{ width: "40px" }}>
                                <MDTypography
                                  color="white"
                                  fontWeight="bold"
                                  fontSize="medium"
                                  overflow="hidden"
                                  textOverflow="ellipsis"
                                  whiteSpace="nowrap"
                                  // width="50px"
                                  sx={{ marginTop: "2px" }}
                                >
                                  {item.price}
                                </MDTypography>
                              </MDBox>
                            </MDBox>
                            <MDBox>
                              <MDTypography
                                sx={{
                                  fontSize: isTabletOrMobile ? "8px" : "10px",
                                  color: "#BDAAC1",
                                }}
                              >
                                Current price
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        )}
                      </MDBox>
                    </MDBox>
                    <MDBox sx={{ width: "100%", padding: "10px" }}>
                      <MDButton
                        fullWidth
                        sx={{
                          borderRadius: "10px",
                          backgroundImage:
                            "linear-gradient(90deg, rgba(74, 74, 74, 0.8) 20%, rgba(255, 147, 8, 0.9) 80%);",
                          // border:"1px solid #FF9607",
                          color: "#ffffff",
                        }}
                      >
                        {/* {item.userDetails.username === localStorage.userNameSingh
                        ? "View Details"
                        : "Buy Now"} */}

                        {searchParams.get("status") === "Not for sale"
                          ? item.userDetails.walletAddress === address
                            ? "Set for sale"
                            : "View Details"
                          : item.userDetails.walletAddress === address
                          ? "View Details"
                          : "Buy Now"}
                      </MDButton>
                    </MDBox>
                  </Card>
                ))}
            </MDBox>
          </MDBox>
        </InfiniteScroll>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}
// ReactDOM.render(<DemoCarousel />, document.querySelector('.demo-carousel'));
export default SeeAll;
